import { Tooltip, TooltipPopup, TooltipTrigger } from "@/components/ui/tooltip";

import type { AgentFeedbackStep } from "./agent-feedback-steps";

interface StepsBulletProps {
  steps: AgentFeedbackStep[];
  currentStep: number;
}

/** Port of components/agent-feedback/StepsBullet.vue. */
export function StepsBullet({ steps, currentStep }: StepsBulletProps) {
  return (
    <nav className="flex items-center justify-center" aria-label="Progress">
      <ol className="mr-8 flex items-center space-x-5">
        {steps.map((step, stepNumber) => (
          <li key={step.name}>
            <Tooltip>
              <TooltipTrigger
                render={
                  stepNumber < currentStep ? (
                    <span className="block h-2.5 w-2.5 rounded-full bg-blue-600 hover:bg-blue-900" />
                  ) : stepNumber === currentStep ? (
                    <span className="relative flex items-center justify-center" aria-current="step">
                      <span className="absolute flex h-5 w-5 p-px" aria-hidden="true">
                        <span className="h-full w-full rounded-full bg-blue-200" />
                      </span>
                      <span
                        className="relative block h-2.5 w-2.5 rounded-full bg-blue-600"
                        aria-hidden="true"
                      />
                    </span>
                  ) : (
                    <span className="block h-2.5 w-2.5 rounded-full bg-gray-200 hover:bg-gray-400" />
                  )
                }
              >
                <span className="sr-only">{step.name}</span>
              </TooltipTrigger>
              <TooltipPopup>{step.name}</TooltipPopup>
            </Tooltip>
          </li>
        ))}
      </ol>

      <p className="text-sm font-medium">
        <span className="mr-2 font-semibold">
          Étape {currentStep + 1} sur {steps.length}
        </span>
        ({steps[currentStep].name})
      </p>
    </nav>
  );
}
